import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { createCompositeCarouselBlocks } from "../elements/equal-width-items.js";
import { buttonColorsOnBlack } from "../elements/nav-button.js";
import "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import "@universityofmaryland/web-utilities-library/events";
const createCompositeCarouselThumbnail = (props) => (() => {
  const { blocks, isThemeDark } = props;
  const slide = new ElementBuilder().build().element;
  const CreatePerson = ({ block }) => new ElementBuilder().withClassName("carousel-person-slide").withStyles({
    element: {
      border: `1px solid ${token.color.gray.light}`,
      ...isThemeDark && { border: `1px solid ${token.color.gray.dark}` },
      borderLeft: "none",
      padding: token.spacing.lg,
      "&:first-child": {
        borderLeft: `1px solid ${token.color.gray.light}`,
        ...isThemeDark && { borderLeft: `1px solid ${token.color.gray.dark}` }
      }
    }
  }).withChild(block).build();
  const blocksWrapperModels = blocks.map((block) => CreatePerson({ block }));
  const blocksWrapper = blocksWrapperModels.map((model) => model.element);
  const blocksStyles = blocksWrapperModels[0] ? blocksWrapperModels[0].styles : "";
  const carousel = createCompositeCarouselBlocks.CreateElement({
    blocks: blocksWrapper,
    slide,
    mobileBreakpoint: token.media.breakpointValues.medium.min,
    tabletBreakpoint: token.media.breakpointValues.desktop.min,
    desktopBreakpoint: token.media.breakpointValues.highDef.min,
    desktopCount: 3,
    maxCount: 4,
    blockGap: 0,
    showHint: false,
    showMobileHint: false,
    button: {
      outsetOffset: token.spacing.md,
      ...isThemeDark && buttonColorsOnBlack()
    }
  });
  const containerModel = new ElementBuilder().withClassName("carousel-thumbnail-container").withStyles({
    element: {
      overflow: "hidden",
      padding: `0 ${token.spacing.md}`,
      ...isThemeDark && { backgroundColor: token.color.black }
    }
  }).withChild(carousel).build();
  const declarationModel = new ElementBuilder().withClassName("carousel-thumbnail-declaration").withStyles({
    element: {
      containerType: "inline-size"
    }
  }).withChild(containerModel).withEvents({
    resize: carousel.events.resize,
    load: carousel.events.load
  }).build();
  declarationModel.styles += blocksStyles;
  return declarationModel;
})();
export {
  createCompositeCarouselThumbnail
};
//# sourceMappingURL=index.js.map
